import { useMsal } from '@azure/msal-react';
import { COMMUNICATION_ADMIN_GROUP_ID } from '../../../features.config';

export function useIsCommunicationAdmin(): boolean {
  const { accounts } = useMsal();
  const groups =
    ((accounts[0]?.idTokenClaims as Record<string, unknown>)?.groups as string[]) ?? [];
  return !!COMMUNICATION_ADMIN_GROUP_ID && groups.includes(COMMUNICATION_ADMIN_GROUP_ID);
}
